import axiosInstance from './axiosInstance';
import config from '../config';
import { StockMovement } from '../types/stockMovements.types';

const API_URL = `${config.API_BASE_URL}/StockMovements`;

export const stockMovementsService = {
  getAll: async (
    movementType?: string,
    itemId?: number,
    warehouseId?: number,
    branchId?: number,
    fromDate?: string,
    toDate?: string
  ): Promise<StockMovement[]> => {
    const params = new URLSearchParams();
    if (movementType) params.append('movementType', movementType);
    if (itemId) params.append('itemId', itemId.toString());
    if (warehouseId) params.append('warehouseId', warehouseId.toString());
    if (branchId) params.append('branchId', branchId.toString());
    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);

    const url = params.toString() ? `${API_URL}?${params.toString()}` : API_URL;
    const response = await axiosInstance.get<StockMovement[]>(url);
    return response.data;
  },
};